import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TutorDeleteActionTypes } from "src/app/constants/StoreConstants";

export const DeleteTutor = createAction(
    TutorDeleteActionTypes.DeleteTutor,
    props<{ tutorIds: number[] }>()
);

export const DeleteTutorSuccess = createAction(
    TutorDeleteActionTypes.DeleteTutorSuccess,
    props<{ result: boolean }>()
);

export const DeleteTutorError = createAction(
    TutorDeleteActionTypes.DeleteTutorError,
    props<{ error: HttpErrorResponse }>()
);

export const ResetDeleteTutorProps = createAction(
    TutorDeleteActionTypes.ResetDeleteTutorProps
);